// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { useContext } from 'react'
import { initI18nReact } from 'typesafe-i18n/react'
import type { I18nContextType, TypesafeI18nProps } from 'typesafe-i18n/react'
import type { Formatters, Locales, Translation, TranslationFunctions, Translations } from './i18n-types'
import { loadedFormatters, loadedLocales } from './i18n-util'

const i18nReact = initI18nReact<Locales, Translations, TranslationFunctions, Formatters>(loadedLocales, loadedFormatters)
const TypesafeI18n: React.FunctionComponent<TypesafeI18nProps<Locales>> = i18nReact.component;
const I18nContext: React.Context<I18nContextType<Locales, Translation, TranslationFunctions>> = i18nReact.context;

const useI18nContext = (): I18nContextType<Locales, Translations, TranslationFunctions> => useContext(I18nContext)

export { I18nContext, useI18nContext }

export default TypesafeI18n
